// extracted by mini-css-extract-plugin
var _1 = "ReorderSidebarItemsModal-module__animateUploadProgressBarWidth--K6WlI";
var _2 = "ReorderSidebarItemsModal-module__animatedBackground--O2yTa";
var _3 = "ReorderSidebarItemsModal-module__header--SOYfb";
var _4 = "ReorderSidebarItemsModal-module__item--U_uyf";
var _5 = "ReorderSidebarItemsModal-module__itemIcon--lmhOy";
var _6 = "ReorderSidebarItemsModal-module__itemName--rmnVN";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "header", _4 as "item", _5 as "itemIcon", _6 as "itemName" }
